import React, { useState } from 'react';
import { BetResponseCode, isMobile, notificationStore, useTranslation } from '@pascal/pascal-core';
import { additionalBetAmountChangingButtons } from '../../../enums/uiConfig';
import { TranslationKeys } from '../../../enums/translationKeys';

const BetAmountSection = ({
  bet,
  doBet,
  index,
  isDemo,
  limits,
  section,
  wageringOdd,
  activeFreeBet,
  // betSections,
  handleInputClick,
  disabledBetButton,
  handleBetSectionsState,
  handleChangeInputValue,
}) => {
  const t = useTranslation();
  const [isValidatedAmount, setIsValidatedAmount] = useState(false);

  const decidedCallBackCall = (callback) => {
    if (isValidatedAmount) {
      setIsValidatedAmount(false);
    } else {
      callback();
    }
  };

  const handleInputBlur = (e) => {
    const value = e.target.value;
    const { minBet, maxBet } = limits;
    // let stake;
    if (!value || Number(value) < minBet) {
      notificationStore.setNotificationType({
        responseCode: BetResponseCode.InValidMinBet,
      });
      setIsValidatedAmount(true);
      // stake = minBet;
      handleBetSectionsState({ changeBet: minBet, index, isBlur: true });
    } else if (Number(value) > maxBet) {
      notificationStore.setNotificationType({
        responseCode: BetResponseCode.InValidMaxBet,
      });
      setIsValidatedAmount(true);
      handleBetSectionsState({ changeBet: maxBet, index, isBlur: true });
    } else {
      handleBetSectionsState({ changeBet: e.target.value, index, isBlur: true });
    }
  };

  return (
    <div className='betting-calc-block'>
      <div className='betting-calc-top-panel'>
        <button
          type='button'
          disabled={activeFreeBet.id && !isDemo}
          className={`betting-calc-nav fs-icon-minus ${
            !activeFreeBet.id && !isDemo ? '' : 'disabled'
          }`}
          data-role='minus'
          onClick={() => handleChangeInputValue(index, additionalBetAmountChangingButtons.minus)}
        />
        <label className='fs-calc-num'>
          <input
            inputMode={isMobile() ? 'none' : 'text'}
            type='text'
            className='fs-calc-num'
            value={activeFreeBet.id && !isDemo ? activeFreeBet.amount : bet || ''}
            onChange={(e) => {
              if (!/^[.,]/.test(e.target.value) && /^\d*[.,]?\d*$/.test(e.target.value)) {
                handleBetSectionsState({ changeBet: e.target.value, index });
              }
            }}
            onBlur={handleInputBlur}
            maxLength={9}
            onTouchStart={() => handleInputClick(index)}
            onMouseDown={() => handleInputClick(index)}
            onClick={() => handleInputClick(index, true)}
          />
        </label>
        <button
          type='button'
          className={`betting-calc-nav fs-icon-plus ${
            !activeFreeBet.id && !isDemo ? '' : 'disabled'
          }`}
          disabled={activeFreeBet.id && !isDemo}
          data-role='plus'
          onClick={() => handleChangeInputValue(index, additionalBetAmountChangingButtons.plus)}
        />
      </div>
      <div className='betting-calc-bottom-panel'>
        <button
          type='button'
          className='betting-calc-variant-wrapper'
          disabled={bet === limits?.minBet || (activeFreeBet.id && !isDemo)}
          onClick={() => handleChangeInputValue(index, additionalBetAmountChangingButtons.min)}
        >
          {t(TranslationKeys.MIN)}
        </button>
        <button
          type='button'
          className='betting-calc-variant-wrapper'
          disabled={activeFreeBet.id && !isDemo}
          onClick={() =>
            handleChangeInputValue(index, additionalBetAmountChangingButtons.multiply, 3)
          }
        >
          x3
        </button>
        <button
          type='button'
          className='betting-calc-variant-wrapper'
          disabled={activeFreeBet.id && !isDemo}
          onClick={() =>
            handleChangeInputValue(index, additionalBetAmountChangingButtons.divide, 2)
          }
        >
          1/2
        </button>
        <button
          type='button'
          className='betting-calc-variant-wrapper'
          disabled={activeFreeBet.id && !isDemo}
          onClick={() =>
            handleChangeInputValue(index, additionalBetAmountChangingButtons.multiply, 2)
          }
        >
          x2
        </button>
      </div>
      <button
        className={`fs-action-panel-button ${activeFreeBet.id || wageringOdd ? 'free-bet' : ''} ${
          disabledBetButton[index] ? '' : 'pulse'
        }`}
        data-type='bet'
        type='button'
        onClick={() => decidedCallBackCall(() => doBet(section.index))}
        disabled={disabledBetButton[index]}
      >
        <p className='fs-action-panel-button-txt'>
          {activeFreeBet.id && !isDemo
            ? `${t(TranslationKeys.FREE_BET)} ${activeFreeBet?.remainingCount}`
            : t(TranslationKeys.BET)}
        </p>
        <p className={`btn-game-small-txt ${disabledBetButton[index] ? 'disabled' : ''}`}>
          {!isDemo && ((activeFreeBet.id && !activeFreeBet.isMinOddNull) || wageringOdd)
            ? `${t(TranslationKeys.MIN_ODD)} x${
                activeFreeBet?.id && !activeFreeBet.isMinOddNull
                  ? activeFreeBet.minOdd
                  : wageringOdd
              }`
            : ''}
        </p>
      </button>
    </div>
  );
};
export default BetAmountSection;
